export const Softlist = [
	/*
	id 			固有のID。
	title		アプリケーション/ゲームのタイトル。
	ver 		バージョン
	update  	最終更新
	build  		開発環境
	copy		キャッチコピー
	desc…		一言コメント
	img			ソフトイメージ画像
	download 	ダウンロードリンク
	tags		検索用タグ

	flags		特殊な操作で表示するソフトか否か　特殊な操作をしないと非表示=true  常に表示=false


	*/

	{
		id:"game190123",
		title:"わからない",
		ver:"1.0",
		update:"2019-01-23",
		build:"Hot Soup Processor 3.51",
		copy:"わからないんだ。なにもかも。",
		description:"絵本のような作品です。\n音はありません。",
		img:"/src-soft/game190123/image.png",
		download:"/src-soft/game190123/wakara.zip",
		tags:["ゲーム","軽度のジャンプスケア","不気味","短編"],

		flags:"false",
	},

	{

		id:"game190226",
		title:"memory hunter",
		ver:"1.0",
		update:"2019-02-26",
		build:"Hot Soup Processor 3.51",
		copy:"ぼくらは、かんがえをかくさなければいけない。",
		description:"短編です。",
		img:"/src-soft/game190226/image.png",
		download:"/src-soft/game190226/memory_hunter.zip",
		tags:["ゲーム","皮肉","短編"],

		flags:"false",

	},


	{

		id:"game190516",
		title:"Timeline",
		ver:"1.02",
		update:"2019-05-16",
		build:"Hot Soup Processor 3.51",
		copy:"自由に呟いてみましょう。",
		description:"SNSチックな短編です。",
		img:"/src-soft/game190516/image.png",
		download:"/src-soft/game190516/timeline.zip",
		tags:["ゲーム","SNS風","静かな狂気","短編"],

		flags:"false",

	},

	{

		id:"soft201023",
		title:"憂",
		ver:"1.0",
		update:"2020-10-23",
		build:"Hot Soup Processor 3.6",
		copy:"それは誰かの人生のストーリー。",
		description:"映像作品です。\n実行には1920 × 1080サイズのモニター推奨です。",
		img:"/src-soft/soft201023/image.png",
		download:"/src-soft/soft201023/urei.zip",
		tags:["映像作品","静かな狂気","短編"],

		flags:"false",

	},

	{

		id:"game210614",
		title:"no name",
		ver:"1.0",
		update:"2021-06-14",
		build:"Hot Soup Processor 3.6",
		copy:"名もなき日常",
		description:"何れ訪れる非日常\n\nそれでも回る日常\n\n今日もどこかで起こる非日常\n\n短編作品です。",
		img:"/src-soft/game210614/image.png",
		download:"/src-soft/game210614/no_name.zip",
		tags:["ゲーム","静かな狂気","短編"],

		flags:"false",

	},

	{

		id:"game180829",
		title:"シャドー",
		ver:"1.0",
		update:"2018-08-29",
		build:"Hot Soup Processor",
		copy:"あなたは影の人間ですか？",
		description:"それとも光の人間ですか？\n\n短編作品です。",
		img:"/src-soft/game180829/image.png",
		download:"/src-soft/game180829/syado.zip",
		tags:["ゲーム","静かな狂気","短編"],

		flags:"false",

	},


	{

		id:"game150907",
		title:"うつになっちゃった。",
		ver:"3.0",
		update:"2015-09-07",
		build:"Hot Soup Processor",
		copy:"ﾈｪ､ﾀﾉｼｲﾉ?",
		description:"短編作品です。\n\n※古い作品なので、不具合が出る可能性があります。\nご了承下さい。",
		img:"/src-soft/game150907/image.jpg",
		download:"/src-soft/game150907/utyu.zip",
		tags:["ゲーム","不気味","軽度のジャンプスケア","短編"],

		flags:"false",

	},


	{

		id:"game160303",
		title:"Good bye bordar",
		ver:"1.04",
		update:"2016-10-22",
		build:"Hot Soup Processor",
		copy:"わたしはもうつかれました。あの”ばしょ”にとどまることに。",
		description:"このゲームは、どこかから逃げてきたものの行く末を見るゲームです。\nそんな「もの」の見てきた世界を、見てみませんか。\n\n中～長編です。約2時間で一周できます。\n\nHSPプログラムコンテスト2016 JBOYSOFT賞 受賞作品",
		img:"/src-soft/game160303/image.png",
		download:"/src-soft/game160303/Goodbyebordar Ver1.04.zip",
		tags:["ゲーム","不気味","軽度のジャンプスケア","長編"],

		flags:"false",

	},

	{

		id:"game151114",
		title:"T F",
		ver:"2.1",
		update:"2015-11-14",
		build:"Hot Soup Processor",
		copy:"ひとでは　ない　ものを　みる",
		description:"このゲームは、次々と現れる「シチュエーション」を見るゲームです。\nつまり、冒険をしたり、美少女と戯れたりしたい人にはおすすめできません。\n\n\n※このゲームは制作からかなりの年月が経っており、\n意図した動作にならない可能性があります。\nあらかじめご了承下さい。",
		img:"/src-soft/game151114/image.png",
		download:"/src-soft/game151114/T_F.zip",
		tags:["ゲーム","不気味","長編"],

		flags:"true",

	},




]
export default Softlist